import { Injectable } from '@angular/core';

import { BaseService } from '../base/services';
import { __ } from '../functions/object.functions';

const key = `intello_redirect_uri_qzweuiaijsdoasdasd`;

@Injectable()
export class RedirectService extends BaseService {

    private _redirectUri: string;

    get redirectUri(): string {
        return this._redirectUri ?? localStorage.getItem(key);
    }
    set redirectUri(value: string) {
        this._redirectUri = value;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ CONSTRUCTOR
    // -----------------------------------------------------------------------------------------------------

    constructor() {
        super();
    }

    setRedirectUri(redirectUri: string): void {
        // The latest location wins: a value left behind by an earlier, interrupted login must not send the user
        // to a stale page after this one
        if (__.IsNullOrUndefinedOrEmpty(redirectUri)) {
            return;
        }

        localStorage.setItem(key, redirectUri);
        this.redirectUri = redirectUri;
    }

    reset(): void {
        this.redirectUri = null;
        localStorage.removeItem(key);
    }
}
